import BaseResource from './index'

export default class CustomDocResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/documents'
}
